import { render, staticRenderFns } from "./PaieskaMano.vue?vue&type=template&id=02cc7dd0&scoped=true&"
import script from "./PaieskaMano.vue?vue&type=script&lang=js&"
export * from "./PaieskaMano.vue?vue&type=script&lang=js&"
import style0 from "./PaieskaMano.vue?vue&type=style&index=0&id=02cc7dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cc7dd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
